import styled, { css } from 'styled-components';

export const PanelWrapper = styled.div`
  background-color: white;
  border: 1px solid ${props => props.theme.carvana.gray.light};
  border-radius: 4px;
  overflow: hidden;
`;

const panelPadding = '30px';

export const PanelHeader = styled.div`
  align-items: center;
  background-color: ${props => props.theme.carvana.blue.medium};
  color: ${props => props.theme.carvana.white.primary};
  display: flex;
  padding: 0 ${panelPadding};
  min-height: 75px;
  width: 100%;

  ${props => props.errorState === true && css`
    background-color: ${props.theme.carvana.red.primary};
  `}

  ${props => props.completedState === true && css`
    background-color: ${props.theme.carvana.green.primary};
  `}
`;

export const PanelBody = styled.div`
  padding-left: ${panelPadding};
  padding-right: ${panelPadding};
`;
